import { useMemo } from 'react'
import type { StripeElementLocale } from '@stripe/stripe-js'
import { useIntl } from 'react-intl'
import { LabRemoteConfigKeys } from 'constants/lab'
import { useLabRemoteConfig } from 'hooks/FeatureFlag/useLabRemoteConfig'
import { getLanguageOptions } from 'i18n/util/locale'
import { getStripeElementsLocale } from 'lib/payment/stripeUtils'
import { isLEStaff } from 'selectors/accountSelectors'
import { useAppSelector } from 'hooks/reduxHooks'

export function useStripeElementsLocale(): StripeElementLocale {
  const intl = useIntl()
  const isStaff = useAppSelector(isLEStaff)
  const languagesRemoteConfig = useLabRemoteConfig(LabRemoteConfigKeys.languages)

  return useMemo(() => {
    return getStripeElementsLocale(
      intl.locale,
      getLanguageOptions(languagesRemoteConfig, isStaff).languageOptions.map(({ locale }) => locale),
    )
  }, [intl.locale, isStaff, languagesRemoteConfig])
}
